import * as dynamicsActions from "./actions/dynamicsActions";
import * as dynamicsExportActions from "./actions/export/dynamics";
import * as hubspotActions from "./actions/hubspotActions";
import * as salesforceActions from "./actions/salesforceActions";
import * as salesforceExportActions from "./actions/export/salesforce";
import * as hubspotExportActions from "./actions/export/hubspot";
import * as suppressionListActions from "./actions/suppressionListActions";
import * as manageIntegrationModalActions from "./actions/export/modal";
import * as manageCommonActions from "./actions/common";

export const managementActions = {
    hubspot: { ...hubspotActions, ...hubspotExportActions },
    salesforce: { ...salesforceActions, ...salesforceExportActions },
    dynamics: { ...dynamicsActions, ...dynamicsExportActions },
    suppressionList: { ...suppressionListActions },
    manageIntegrationModal: { ...manageIntegrationModalActions },
    common: { ...manageCommonActions },
};

export const SuppressionListActions = suppressionListActions;
const SalesforceActions = salesforceActions;
